export const cleanPath = (url: string): string =>
	new URL(url).pathname.replace(/\/$/, '');
